import {
  type Country as MelwaysCountry,
  getClassificationFromSiteName,
  type SiteName,
} from '@seek/melways-sites';

import type { Country } from '@seek/chalice-types';

const mapToProperCountry = (country?: MelwaysCountry | null): Country =>
  country?.toUpperCase() as Country;

export const mapToMelwaysCountry = (country?: Country): MelwaysCountry =>
  country?.toLowerCase() as MelwaysCountry;

export const getCountryFromSite = (site: SiteName): Country =>
  mapToProperCountry(
    getClassificationFromSiteName(mapToMelwaysSiteName(site))?.country,
  );

// Due to sku config providing "site" as a string ..
// .. we need to map it to the Melways SiteName type
// TODO: We will need to remove `au` and `nz` from this map ..
// .. once melways sites are updated to use proper site names for ANZ
export const mapToMelwaysSiteName = (site: string): SiteName => {
  switch (site) {
    case 'au':
      return 'candidate-seek-au';

    case 'nz':
      return 'candidate-seek-nz';

    default:
      return site as SiteName;
  }
};
